<ng-container *ngIf="order$ | async as order">
  <ng-container *ngIf="!(isOrderLoading$ | async)">
    <ng-container
      *ngIf="
        order.consignments?.length ||
        order.unconsignedEntries?.length ||
        getReplenishmentOrderCode(order)
      "
    >
      <cx-promotions
        [promotions]="order.appliedOrderPromotions || []"
      ></cx-promotions>
    </ng-container>
    <div
      *ngIf="pickupConsignments?.length"
      class="cx-pickup-order-consigned-entries-header"
    >
      {{ 'deliveryPointOfServiceDetails.itemsToBePickUp' | cxTranslate }}
    </div>
    <app-gonvarri-order-consigned-entries
      *ngIf="pickupConsignments"
      [order]="order"
      [consignments]="getConsignments(pickupConsignments)"
      [enableAddToCart]="getEnableAddToCart(enableAddToCart$ | async)"
      [buyItAgainTranslation]="'addToCart.buyItAgain' | cxTranslate"
    ></app-gonvarri-order-consigned-entries>

    <cx-cart-details
      *ngIf="
        deliveryConsignments &&
        deliveryConsignments.length > 0 &&
        (groupCartItems$ | async)
      "
      [customCart]="order"
      [showPromotions]="false"
    />

    <!-- delivery consigned entries -->
    <app-gonvarri-order-consigned-entries
      *ngIf="deliveryConsignments"
      [order]="order"
      [consignments]="getConsignments(deliveryConsignments)"
      [enableAddToCart]="getEnableAddToCart(enableAddToCart$ | async)"
      [buyItAgainTranslation]="'addToCart.buyItAgain' | cxTranslate"
    />

    <!-- unconsigned entries -->
    <ng-container *ngIf="order?.unconsignedEntries?.length">
      <div *ngIf="order?.statusDisplay" class="cx-list-header">
        <div class="cx-list-status">
          {{
            'orderDetails.statusDisplay_' + order?.statusDisplay | cxTranslate
          }}
        </div>
      </div>
      <!-- delivery unconsigned entries -->
      <ng-container *ngIf="deliveryUnConsignedEntries?.length">
        <h2 *ngIf="groupCartItems$ | async" class="cx-review-header">
          {{ 'checkoutMode.deliveryEntries' | cxTranslate }}
        </h2>
        <div class="cx-list-item">
          <cx-cart-details
            [customCart]="order"
            [showPromotions]="false"
          />
        </div>
      </ng-container>
      <!-- pickup unconsigned entries, b2b does not have pickup items -->
      <ng-container *ngIf="pickupUnconsignedEntries?.length">
        <h2 class="cx-review-header">
          {{ 'checkoutPickupInStore.heading' | cxTranslate }}
        </h2>
        <div class="cx-list-item">
          <cx-cart-details
            [customCart]="order"
            [showPromotions]="false"
          />
        </div>
      </ng-container>
    </ng-container>

    <!-- replenishment other entries -->
    <ng-container *ngIf="order?.entries && getReplenishmentOrderCode(order)">
      <div class="cx-list">
        <div *ngIf="order?.statusDisplay" class="cx-list-header">
          <div class="cx-list-status">
            {{
              'orderDetails.statusDisplay_' + order?.statusDisplay | cxTranslate
            }}
          </div>
        </div>
        <div class="cx-list-item">
          <cx-cart-details
            [customCart]="order"
            [showPromotions]="false"
          />
        </div>
      </div>
    </ng-container>
    <div class="cx-payment-details">
      <div class="cx-payment-details__title">
        {{ 'orderDetails.payment.title' | cxTranslate }}
      </div>
      <div class="cx-payment-details__bottom">
        <h2 class="cx-payment-details__bottom__subtitle">
          {{ 'orderDetails.payment.subtitle' | cxTranslate }}
        </h2>
        <div>
          <div class="cx-payment-details__bottom__user">
            <span>{{ 'orderDetails.payment.user' | cxTranslate}}</span> {{order.orgUnit?.name}}
          </div>
          <div class="cx-payment-details__bottom__clientNumber">
            <span>{{ 'orderDetails.payment.clientNumber' | cxTranslate}}</span> {{order.orgUnit?.uid}}
          </div>
          <div class="cx-payment-details__bottom__orderNumber">
            <span>{{ 'orderDetails.payment.orderNumber' | cxTranslate}}</span> {{order.purchaseOrderNumber}}
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template let-ctx #addToCartBtn>
    <cx-add-to-cart
      [productCode]="ctx.item.product?.code"
      [product]="ctx.item.product"
      [showQuantity]="false"
      [options]="ctx.options"
      [pickupStore]="ctx.item.deliveryPointOfService?.name"
      class="add-to-cart"
    ></cx-add-to-cart>
  </ng-template>
</ng-container>
